import { useCallback } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { paymentsActions } from '../../store';

export const useGetRecommendedDepositAmount = () => {
  const { payments = {} } = useOtherSettings();
  const { isRecommendedDepositAmount } = payments;

  const getRecommendedDepositAmount = useCallback(() => {
    if (isRecommendedDepositAmount) {
      paymentsActions.GET_RECOMMENDED_DEPOSIT_AMOUNT();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    getRecommendedDepositAmount
  };
};
